import { DebtChartData } from '../../core/utils/DebtUtils'

type PriorityDisplay = number | '!' | '✓'

export function priorityComparator(a: PriorityDisplay, b: PriorityDisplay) {
  const getWeight = (value: PriorityDisplay) => {
    if (typeof value === 'number') return value // Numbers sorted naturally
    if (value === '!') return Infinity - 1 // '!' comes after numbers
    if (value === '✓') return Infinity // '✓' comes last
    throw new Error('Unsupported value')
  }
  return getWeight(a) - getWeight(b) // Compare based on weights
}

export function getPriorityValue(debt: DebtChartData) {
  if (debt.is_paid_off) return '✓'
  if (debt.priority === undefined || debt.is_impossible) return '!'
  return debt.priority
}
